// src/Components/Popup.js
import React from 'react';
import { createPortal } from 'react-dom';
import './styles/popup.css';

function Popup({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;

    return createPortal(
        <div className="popup-overlay" role="presentation" onMouseDown={onClose}>
            <div
                className="popup-content"
                role="dialog"
                aria-modal="true"
                aria-labelledby="popup-title"
                onMouseDown={(event) => event.stopPropagation()}
            >
                <div className="popup-header">
                    <h2 id="popup-title">{title}</h2>
                    <button className="popup-close" onClick={onClose} aria-label="Close dialog">×</button>
                </div>
                <div className="popup-body">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
}

export default Popup;
